import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { appelApi } from './api';

/**
 * Attribution des antennes au pôle pédagogique (écran `dir-attributions`,
 * direction seule) : l'équipe, ses antennes, et le choix unique de
 * l'assistant(e) de site, tels que l'API les rend.
 */

export interface MembreAttribue {
  id: string;
  nom: string;
  prenom: string;
  fonction: string;
  sites: string[];
  uneSeuleAntenne: boolean;
}

export interface VueAttributions {
  antennes: { code: string; nom: string }[];
  membres: MembreAttribue[];
}

const CLE_ATTRIBUTIONS = ['attributions'] as const;

export function useAttributions() {
  return useQuery({
    queryKey: CLE_ATTRIBUTIONS,
    queryFn: () => appelApi<VueAttributions>('/attributions'),
  });
}

export function useAttribuerSites() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ utilisateurId, sites }: { utilisateurId: string; sites: string[] }) =>
      appelApi<VueAttributions>(`/attributions/${utilisateurId}`, { methode: 'PUT', corps: { sites } }),
    onSuccess: (vue) => client.setQueryData(CLE_ATTRIBUTIONS, vue),
  });
}
